// src/tiles/NextJobTile.jsx
import React from 'react';
import TileShell from './TileShell';
import ReceiptsList from './ReceiptsList';
import { Chip } from '@mui/material';

export default function NextJobTile({ title, frequency, receipts }) {
  const metricsRow = (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
      <Chip size="small" label={`Frequency: ${frequency}`} />
    </div>
  );

  return (
    <TileShell
      typePill="nextjob"
      title={title}
      metricsRow={metricsRow}
      receipts={<ReceiptsList receipts={receipts || []} />}
    />
  );
}
